import { DemoTag } from "e.sic-platform.webclient/src/components/grid-tag/Tags";
import { currentUserService } from "e.sic-platform.webclient/src/services/user/CurrentUserStorage"
import { observer } from "mobx-react-lite"

export default observer(function UserTag() {
    const demo = currentUserService.currentUser.isDemo;

    if (demo) return (<DemoTag />)
    else return (<></>)
})